export default {
  /* buildDoughnutChart
  expects the subscription response object as subscription
  function sets these properties in the vue context
  enabledUsers
  pendingUsers
  remainingSlots
  exceededInvites
  dictationUsers
  nonDictationUsers
  chartData
  */
  buildDoughnutChart (subscription) {
    if (!subscription) {
      console.warn("undefined subscription response passed to buildDoughnutChart");
      return;
    }
    this.enabledUsers = parseInt(subscription.number_of_users);
    this.pendingUsers = parseInt(subscription.pending_invites);
    this.remainingSlots = parseInt(subscription.product.number_of_seats) - (this.enabledUsers + this.pendingUsers);
    this.exceededInvites = -1 * (this.remainingSlots);

    // TODO (Adam) reliant on implicit business logic, replace with field in subscription response
    this.dictationUsers = this.enabledUsers;
    this.verifiedUsers = parseInt(this.subscription.number_of_verified_users);
    // if total users exceeds product's number of users, we know there is a manager included
    if (this.dictationUsers > subscription.product.number_of_users) {
      this.dictationUsers = parseInt(subscription.product.number_of_users);
      this.nonDictationUsers = parseInt(subscription.product.number_of_seats) - this.dictationUsers;
    } else {
      // subscription.product.number_of_users;
      this.nonDictationUsers = 0;
    }
    if (this.remainingSlots < 0) {
      this.remainingSlots = 0;
    }
    // exceeded invites shouldn't be a thing anymore
    if (this.exceededInvites > 0) {
      this.pendingUsers -= this.exceededInvites;
    }
    this.chartData = {
      labels: ["Enabled Users", "Pending Invites", "Remaining Slots"],
      datasets: [{
        labels: ["Enabled Users", "Pending Invites", "Remaining Slots"],
        data: [this.enabledUsers, this.pendingUsers, this.remainingSlots],
        backgroundColor: ["rgb(254,180,46)", "rgb(3,134,183)", "rgb(196,196,196)"],
        borderColor: ["rgb(254,180,46)", "rgb(3,134,183)", "rgb(196,196,196)"],
        borderWidth: 1,
      }],
    };

    if (this.exceededInvites > 0) {
      // doesn't make sense in the donut chart
      const rgbValue = "rgb(245, 76, 87)";
      this.chartData.labels.push("Exceeded Invites");
      this.chartData.datasets[0].labels.push("Exceeded Invites");
      this.chartData.datasets[0].data.push(this.exceededInvites);
      this.chartData.datasets[0].data[0] -= this.exceededInvites;
      this.chartData.datasets[0].backgroundColor.push(rgbValue);
      this.chartData.datasets[0].borderColor.push(rgbValue);
    }

    if (this.nonDictationUsers > 0) {
      const rgbValue = "rgba(82, 186, 226)";
      this.chartData.labels.push("Manager Seats Filled");
      this.chartData.datasets[0].labels.push("Managers");
      this.chartData.datasets[0].data.push(this.nonDictationUsers);
      // removing the manager count from enabled users count, in the chart visually this is a more clear representation
      this.chartData.datasets[0].data[0] -= this.nonDictationUsers;
      this.chartData.datasets[0].backgroundColor.push(rgbValue);
      this.chartData.datasets[0].borderColor.push(rgbValue);
    }



  },
};
